import { LOGOUT } from './authentication.ationTypes';
import setToken from './setToken';

export default () => dispatch => {
  dispatch({ type: LOGOUT });
  dispatch(setToken());
};
